import { status } from '@/store/model/sport/football/Status'

const bytes = (bytes) => {
  if (bytes && bytes > 0) {
    bytes = Math.abs(parseInt(bytes, 10))
    const def = [[1, ''], [1024, 'k'], [1024 * 1024, 'M'], [1024 * 1024 * 1024, 'G'], [1024 * 1024 * 1024 * 1024, 'T']]
    for (let i = 0; i < def.length; i++) {
      if (bytes < def[i][0]) {
        let value = bytes / def[i - 1][0]
        const dec = Math.abs(parseFloat(value.toFixed(2)) - parseInt(value))
        if (dec > 0 && dec < 1) {
          value = value.toFixed(2)
        } else {
          value = Math.round(value)
        }
        return value + ' ' + def[i - 1][1]
      }
    }
  }
  return 'n/a'
}

const percent = (value) => {
  return Math.round(value * 100) + '%'
}

const percentValue = (total, value) => {
  return total > 0 ? value / total : 0
}

const statusValue = (low, high, value) => {
  return value > high ? 0 : (value > low ? 1 : 2)
}

const timeLength = (start, end) => {
  let value = null
  if (start instanceof Date) {
    if (!end) {
      end = new Date()
    }
    if (end instanceof Date) {
      const diff = new Date(end - start).valueOf()
      let seconds = parseInt(diff / 1000)
      let minutes = parseInt(seconds / 60)
      let hours = parseInt(minutes / 60)
      const days = parseInt(hours / 24)
      if (days > 0) {
        hours = hours - (24 * days)
      }
      if (days > 0 || hours > 0) {
        minutes = minutes - (24 * 60 * days) - (60 * hours)
      }
      if (days > 0 || hours > 0 || minutes > 0) {
        seconds = seconds - (24 * 60 * 60 * days) - (60 * 60 * hours) - (60 * minutes)
      }
      value = seconds + 's'
      if (days > 0 || hours > 0 || minutes > 0) {
        value = minutes + 'm' + (seconds < 10 ? '0' + seconds : seconds) + 's'
      }
      if (days > 0 || hours > 0) {
        value = hours + 'h' + (minutes < 10 ? '0' + minutes : minutes) + 'm' + (seconds < 10 ? '0' + seconds : seconds) + 's'
      }
      if (days > 0) {
        value = days + 'd' + (hours < 10 ? '0' + hours : hours) + 'h' + (minutes < 10 ? '0' + minutes : minutes) + 'm' + (seconds < 10 ? '0' + seconds : seconds) + 's'
      }
    }
  }
  return value
}

const stopwatch = (start, end, statusId) => {
  let value = null
  if (status.stopwatch(statusId) === true && start instanceof Date && end instanceof Date) {
    const diff = end - start
    let seconds = parseInt(diff / 1000)
    let minutes = parseInt(seconds / 60)
    seconds = seconds - (60 * minutes)
    minutes = (status.stopwatchOffset(statusId) + minutes)
    value = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
  }
  return value
}

const ucFirst = (value) => {
  return value && value.length > 0 ? value[0].toUpperCase() + value.substring(1) : value
}

const date = (value) => {
  const date = new Date(value)
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  const year = date.getFullYear()
  return year + '-' + month + '-' + day
}

const time = (value) => {
  const date = new Date(value)
  const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  return hours + ':' + minutes
}

export { bytes, date, percent, percentValue, statusValue, timeLength, stopwatch, time, ucFirst }
